import { ILegalFormExtendedDTO } from '@modeso/types__aumico-lib-settings-be';
import { createEntityAdapter, Dictionary, EntityAdapter } from '@ngrx/entity';
import { Action, createReducer, createSelector, MemoizedSelector, on } from '@ngrx/store';
import * as settingsActions from '../actions/settings.actions';
import { ILegalFormState } from '../interfaces/legal-form-state.interface';

function selectLegalFormId(a: ILegalFormExtendedDTO): string {
    return a._id;
}

function sortByName(a: ILegalFormExtendedDTO, b: ILegalFormExtendedDTO): number {
    return a.name.localeCompare(b.name);
}

const adapter: EntityAdapter<ILegalFormExtendedDTO> = createEntityAdapter<ILegalFormExtendedDTO>({
    selectId: selectLegalFormId,
    sortComparer: sortByName,
});

const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();

const selectEntity = createSelector(
    selectEntities,
    (entities: Dictionary<ILegalFormExtendedDTO>, props: { id: string }) => entities[props.id],
);

export const initialLegalFormState: ILegalFormState = adapter.getInitialState({
    // additional entity state properties
    // activeVariable: null,
});

export function createSelectors<T>(legalFormStateSelector: MemoizedSelector<T, ILegalFormState>) {
    return {
        selectAll: createSelector(legalFormStateSelector, selectAll),
        selectEntities: createSelector(legalFormStateSelector, selectEntities),
        selectActive: createSelector(legalFormStateSelector, (state) => state.activeLegalForm),
        selectError: createSelector(legalFormStateSelector, (state) => state.error),
    };
}

const privateAccountingBasesReducer = createReducer(
    initialLegalFormState,
    on(settingsActions.legalFormActions.onGetAllLegalFormSuccess, (state, action) =>
        adapter.setAll(action.payload, { ...state, error: undefined }),
    ),
    on(settingsActions.legalFormActions.onGetAllLegalFormFailed, (state, action) => ({
        ...state,
        error: action.payload,
    })),
    on(settingsActions.legalFormActions.setActiveLegalForm, (state, action) => ({
        ...state,
        error: undefined,
        activeLegalForm:
            typeof action.payload === 'string' ? selectEntity(state, { id: action.payload }) : action.payload,
    })),

    on(settingsActions.legalFormActions.onSubmitCreateLegalFormSuccess, (state, action) => ({
        ...state,
        error: undefined,
        activeLegalForm: null,
    })),
    on(settingsActions.legalFormActions.onSubmitCreateLegalFormFailed, (state, action) => ({
        ...state,
        error: action.payload,
    })),
    on(settingsActions.legalFormActions.onSubmitEditLegalFormSuccess, (state, action) => ({
        ...state,
        error: undefined,
        activeLegalForm: null,
    })),
    on(settingsActions.legalFormActions.onSubmitEditLegalFormFailed, (state, action) => ({
        ...state,
        error: action.payload,
    })),
);

export function legalFormsReducer(state: ILegalFormState | undefined, action: Action) {
    return privateAccountingBasesReducer(state, action);
}
